import {Modal} from "ui/base/modal/Modal";
import styled from "styled-components";
import {ButtonPrimary} from "ui/base/Button/ButtonStyled";
import { LoaderComponent, PAGE_HEIGHT } from "ui/base/loading/LoaderComponent";
import {calculateRefundAmount} from "api/booking.api";
import {useEffect} from "react";
import {useQuery} from "@tanstack/react-query";

export const CancelClassModal = ({
                                     show,
                                     bookingId,
                                     role,
                                     handleClose,
                                     handleCancelClass,
                                 }) => {
    const {data, isLoading, refetch} = useQuery({
        queryKey: ["refundData", bookingId, role],
        queryFn: () =>
            calculateRefundAmount({
                booking_id: bookingId,
                type: role,
            }),
        enabled: false,
    });

    useEffect(() => {
        if (!show) return;
        refetch();
    }, [show, bookingId, role]);

    return (
        <Modal show={show} handleClose={handleClose} maxWidth={425} minHeight={184}>
            <Container>
                <Title>
                    Do you want to cancel your class request?
                </Title>

                {isLoading ? (
                    <LoaderComponent minHeight="120px" />
                ) : (
                    <>
                        <Description>
                            Payment will be refunded to your payment method.
                        </Description>
                        <ButtonContainer>
                            <ButtonPrimary onClick={handleCancelClass} variant="outline">
                                Yes
                            </ButtonPrimary>
                            <ButtonPrimary onClick={handleClose} variant="secondary">
                                No
                            </ButtonPrimary>
                        </ButtonContainer>
                    </>
                )}
            </Container>
        </Modal>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 1rem;
    padding-top: 1rem;
`;

const Title = styled.h2`
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    width: 100%;
`;

const Description = styled.p`
    font-weight: 400;
    font-size: 14px;
    line-height: 155%;
    text-align: center;
    width: 100%;
`;

const ButtonContainer = styled.div`
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
    width: 100%;
`;

